export default __webpack_public_path__ + "static/stream-1d4c25f11f52a49867bd4c53b02c8de7.svg";